import { onMounted, onUnmounted } from "vue";

export function useKeyupEvent(handler) {
    onMounted(() => document.addEventListener("keyup", handler));
    onUnmounted(() => document.removeEventListener("keyup", handler));
}
